var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.blocks),function(block,index){return _c(_vm.blockType(block.__component),{key:index,tag:"component",attrs:{"content":block}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }